import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from '@services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private auth: AuthService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    const noToken: boolean = !!request.params.get('no-token');
    if (noToken) {
      const paramsWithoutToken = request.params.delete('no-token');
      const reqWithoutToken = request.clone({params: paramsWithoutToken});
      return next.handle(reqWithoutToken);
    } else {
      const token = this.auth.idToken;
      if (token) {
        const authReq = request.clone({headers: request.headers.set('Authorization', `Bearer ${token}`)});
        return next.handle(authReq);
      } else {
        return next.handle(request);
      }
    }
  }
}
